<template>
  <div class="row">
    <div class="col col-md-7 border rounded-3">
      <paylasim-yap />
      <paylasim-card v-for="i in 5" :key="i" />
    </div>
    <sidefix />
  </div>
</template>
<script>
import Sidefix from "@/components/Shared/Sidefix.vue";
import PaylasimCard from "@/components/Pages/Anasayfa/PaylasimCard.vue";
import PaylasimYap from "@/components/Pages/Anasayfa/PaylasimYap.vue";
export default {
  components: { Sidefix, PaylasimCard, PaylasimYap },
  data() {
    return {
      isLoading: false,
    };
  },
};
</script>

<style></style>
